import { useCallback, useState } from 'react';
import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';

const useTooltipState = () => {
  const isLoggedIn = useIsLoggedIn();

  const message = isLoggedIn ? null : 'casino.sign_in_to_rate';

  const [messageId, setMessageId] = useState<string | null>(message);

  const showTooltip = useCallback((mes: string | null) => {
    setMessageId(mes);
  }, []);

  return { messageId, showTooltip };
};

export default useTooltipState;
